/* Nector : correctifs d'accessibilité, SEO et agents IA appliqués après chargement (y compris sur les blocs injectés par les apps : Judge.me, Instafeed). Aucun effet visuel. */
(function () {
  'use strict';
  var VTT = 'data:text/vtt;charset=utf-8,WEBVTT';

  function nameOf(a) {
    return (a.getAttribute('aria-label') || a.textContent || (a.querySelector('img') && a.querySelector('img').alt) || a.title || '').trim();
  }

  function run() {
    // 1. Liens sans nom visible (logo du header, icônes)
    document.querySelectorAll('a.logo__link, a[href]').forEach(function (a) {
      if (a.closest('[hidden],[aria-hidden="true"]')) return;
      if (nameOf(a)) return;
      if (a.matches('a.logo__link')) a.setAttribute('aria-label', 'Nector, retour à l\'accueil');
    });

    // 2. Liens non explorables (javascript:void(0), href vide) : on en fait des boutons accessibles
    document.querySelectorAll('a[href^="javascript:"], a[href=""]').forEach(function (a) {
      if (a.__nectorFixed) return;
      a.__nectorFixed = true;
      a.setAttribute('role', 'button');
      a.setAttribute('tabindex', '0');
      a.setAttribute('href', '#');
      a.addEventListener('click', function (e) { e.preventDefault(); });
    });

    // 3. Vidéos sans piste de sous-titres (vidéos muettes, sans dialogue) : piste vide déclarée
    document.querySelectorAll('video').forEach(function (v) {
      if (v.querySelector('track[kind="captions"]')) return;
      var t = document.createElement('track');
      t.kind = 'captions'; t.srclang = 'fr'; t.label = 'Vidéo sans dialogue'; t.src = VTT;
      v.appendChild(t);
    });

    // 4. Annotations WebMCP des formulaires (déclaratif)
    var forms = [
      ['form[action$="/search"]', 'rechercher_produits', 'Rechercher un produit ou une page sur nector.fr.'],
      ['form.cart-drawer-form, form[action$="/cart"]', 'modifier_panier', 'Modifier les quantités du panier ou passer au paiement.'],
      ['form[action$="/cart/add"]', 'ajouter_au_panier', 'Ajouter un produit au panier.'],
      ['form#footer-signup_form, form[action*="/contact"]', 'inscription_newsletter', 'S\'inscrire à la newsletter Nector avec une adresse e-mail.']
    ];
    forms.forEach(function (f) {
      document.querySelectorAll(f[0]).forEach(function (el) {
        if (el.hasAttribute('toolname')) return;
        el.setAttribute('toolname', f[1]);
        el.setAttribute('tooldescription', f[2]);
      });
    });
  }

  function start() {
    run();
    // Les apps injectent leurs blocs après coup : on réapplique pendant 15 s, de façon espacée.
    var timer = null;
    var mo = new MutationObserver(function () {
      if (timer) return;
      timer = setTimeout(function () { timer = null; run(); }, 600);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); run(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
